import { Container } from '@cgs/wge';
import { AnticipationConfig } from '../../reels_engine/game_config/game_config';
import { FreeSpinsSoundModel, ReelsSoundModel } from '../../reels_engine/reels_sound_model';
import { T_IGameConfigProvider, RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';
import { ResourcesComponent } from './resources_component';

export class FreeSpinsSoundModelComponent {
  freeSpinSoundModel: ReelsSoundModel;
  constructor(container: Container) {
    console.log('load ' + this.constructor.name);
    const res: ResourcesComponent =
      container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const anticipationConfig =
      container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig.anticipationConfig;
    this.freeSpinSoundModel = new FreeSpinsSoundModel(
      res.sounds,
      anticipationConfig as AnticipationConfig
    );
  }
}
